jQuery(document).on("click", ".node-type-scrapbook .save-clip-star", function(e) {
  clip = jQuery(this).data("id");
  if (jQuery(this).hasClass("active")) {
    axios
      .post(route('clip.unsave', {
        clip: clip
      }))
      .then(response => (this.isSaved = false))
      .catch(response => console.log(response.data));
    jQuery(this).removeClass("active");
  } else {
    axios
      .post(route('clip.save', {
        clip: clip
      }))
      .then(response => {})
      .catch(response => console.log(response.data));
    jQuery(this).addClass("active");
  }
});
jQuery(".btn-font-big.btn.btn-lg.btn-cancel").on("click", function() {
  jQuery("#clip-add-reading").modal("hide");
});
jQuery(document).on("click", ".show-clip-to-book-modal", function() {
  vue = jQuery(obos.__vue__);
  clip_id = jQuery(this).data("clip-id");
  clip_name = jQuery(this).data("clip-name");
  section_id = jQuery(this).data("section-id");
  section_name = jQuery(this).data("section-name");
  vue[0].showClipToBookModal(true, clip_id, clip_name, section_id, section_name);
});

jQuery(document).ready(function(e) {
  function t(t) {
    e(t).bind("click", function(t) {
      t.preventDefault();
      e(this)
        .parent()
        .fadeOut();
    });
  }
  $(".download-modal-link").click(function() {
    axios
      .post("/dsfbdsdalfjsdfsda", { "track-pixel": "DownloadTrigger" })
      .then(function(response) {})
      .catch(function(error) {});
    $("#book-download-modal").modal("show");
    $(this).blur();
    return false;
  });
  e(".dropdown-toggle").click(function() {
    var t = e(this)
      .parents(".button-dropdown")
      .children(".dropdown-menu")
      .is(":hidden");
    e(".button-dropdown .dropdown-menu").hide();
    e(".button-dropdown .dropdown-toggle").removeClass("active");
    if (t) {
      e(this)
        .parents(".button-dropdown")
        .children(".dropdown-menu")
        .toggle()
        .parents(".button-dropdown")
        .children(".dropdown-toggle")
        .addClass("active");
    }
  });
  e(document).on("click", ".dropdown-menu .dropdown-title i", function(t) {
    e(".button-dropdown .dropdown-menu").hide();
    e(".button-dropdown .dropdown-toggle").removeClass("active");
  });
  // e(document).bind("click", function (t) {
  //     console.log('second');
  //     var n = e(t.target);
  //     if (!n.parents().hasClass("button-dropdown")) e(".button-dropdown .dropdown-menu").hide();
  // });
  // e(document).bind("click", function (t) {
  //     var n = e(t.target);
  //     console.log('third');
  //     if (!n.parents().hasClass("button-dropdown")) e(".button-dropdown .dropdown-toggle").removeClass("active");
  // })
});
